const ForestEnvs: Record<string, string> = {
  prod: 'Production',
  testing: 'Testing',
  production: 'Production',
};

const env = process.env.NX_APP_ENV;

const FOREST_ENV =
  !env || !ForestEnvs[env]
    ? 'Development | nicolasdjambazian'
    : ForestEnvs[env];

export const config = {
  TANDEMZ_PANEL: '505d8401-d04c-4b15-91ca-4b009f4c8ad7',
  FOREST_ENV,
  FOREST_URL_PREFIX: `https://app.forestadmin.com/Tandemz/${FOREST_ENV}/Customer%20Success/data`,
  STRIPE_PUBLISHABLE_KEY:
    process.env.NX_STRIPE_PUBLISHABLE_KEY ||
    'pk_test_51KMYBCHv0LZxDwxjEujUmpJCOXBH5WFHVs0T8B8BXlTdeghIM4F2qWrManKun5XksAAoxsYAwnHZBAENqIsd0eDt00WYiWgi83',
};
